import { EmblaOptionsType } from 'embla-carousel';
import React from 'react';

import { CarouselBeta, CarouselSlideBeta } from '@zooplus/ui-components';

import { ENV } from '../../environment';
import { useTranslation } from '../../hooks/use-translations';
import useMedias from '../../hooks/useMedias';

import styles from './CustomerStats.module.scss';
import { FeatureCard } from './FeatureCard';

const options: EmblaOptionsType = {
  align: 'center',
  breakpoints: {
    '(min-width: 0px)': { slidesToScroll: 1 },
    '(min-width: 472px)': { slidesToScroll: 1 },
    '(min-width: 544px)': { slidesToScroll: 1 },
    '(min-width: 600px)': { slidesToScroll: 1 },
    '(min-width: 730px)': { slidesToScroll: 2 },
    '(min-width: 820px)': { slidesToScroll: 2 },
    '(min-width: 800px)': { slidesToScroll: 2 },
    '(min-width: 880px)': { slidesToScroll: 2 },
    '(min-width: 1080px)': { slidesToScroll: 3 },
  },
  slidesToScroll: 1,
};

export const CustomerStats: React.FC = () => {
  const { isTablet, isMobile, isSmallMobile } = useMedias();
  const isDesktop = !isTablet && !isMobile && !isSmallMobile;
  const { t } = useTranslation();
  const features = [
    {
      id: 1,
      icon: `${ENV.IMAGE_CDN}/customer-stats/customer-stats-icon-1.png`,
      description: t('ob.brandusp.usp_1'),
      backgroundColor: 'rgba(193, 227, 234, 1)',
    },
    {
      id: 2,
      icon: `${ENV.IMAGE_CDN}/customer-stats/customer-stats-icon-2.png`,
      description: t('ob.brandusp.usp_2'),
      backgroundColor: 'rgba(255, 237, 176, 1)',
    },
    {
      id: 3,
      icon: `${ENV.IMAGE_CDN}/customer-stats/customer-stats-icon-3.png`,
      description: t('ob.brandusp.usp_3'),
      backgroundColor: 'rgba(251, 213, 215, 1)',
    },
  ];

  return (
    <section className={styles.container}>
      <h2 className={styles.count}>
        4,900,000<span className={styles.countPlus}>+</span>
      </h2>
      <div
        className={styles.progressBar}
        role="progressbar"
        aria-valuenow={100}
        aria-valuemin={0}
        aria-valuemax={100}
      />
      <p className={styles.subtitle}>{t('ob.brandusp.customer.content')}</p>
      {isDesktop ? (
        <div className={styles.featureContainerBig}>
          {features.map((feature) => (
            <FeatureCard
              key={feature.id}
              icon={feature.icon}
              description={feature.description}
              backgroundColor={feature.backgroundColor}
            />
          ))}
        </div>
      ) : (
        <div className={styles.featureContainerSmall}>
          <CarouselBeta
            data-zta="customer-stats-carousel"
            emblaOptions={options}
            gap="16px"
            id="customer-stats-carousel"
            nextButtonAriaLabel="next"
            previousButtonAriaLabel="previous"
            className={styles.carousel}>
            {features.map((feature) => (
              <CarouselSlideBeta
                data-zta={`own-brand-customer-stats-${feature.id}`}
                key={feature.id}
                className={styles.carouselItem}>
                <FeatureCard
                  icon={feature.icon}
                  description={feature.description}
                  backgroundColor={feature.backgroundColor}
                />
              </CarouselSlideBeta>
            ))}
          </CarouselBeta>
        </div>
      )}
    </section>
  );
};
